import React, { useContext } from 'react';

import { ResolvePostBookingInquiryResult } from '@hooks/mutation/useResolvePostBookingInquiry';
import type { BookingInquiryForm } from '@models/BookingInquiry';
import { Country } from '@models/Country';

export interface ManuallyInputState {
  shipper: boolean;
  consignee: boolean;
  receiver: boolean;
}

export interface BookingCreateContextValue {
  isDashboard: boolean;
  ownerId: number;
  ownerCompanyId: number;
  ownerCompanyCountry: Country;
  resolvePostBookingInquiryResult?: ResolvePostBookingInquiryResult;
  setResolvePostBookingInquiryResult: (value: ResolvePostBookingInquiryResult) => void;
  onChangeCreating: (value: boolean) => void;
  initialValues: BookingInquiryForm;
  setInitialValues: (values: BookingInquiryForm) => void;
  initialFormIndexStep: number;
}

export const BookingCreateContext = React.createContext<BookingCreateContextValue>({
  isDashboard: false,
  ownerId: undefined as any,
  ownerCompanyId: undefined as any,
  ownerCompanyCountry: undefined as any,
  resolvePostBookingInquiryResult: undefined,
  setResolvePostBookingInquiryResult: () => {},
  onChangeCreating: () => {},
  initialValues: undefined as any,
  setInitialValues: () => {},
  initialFormIndexStep: 1,
});

export const useBookingCreateContext = () => useContext(BookingCreateContext);
